import slotShouldForwardProp from './slotShouldForwardProp';
const rootShouldForwardProp = prop => slotShouldForwardProp(prop) && prop !== 'classes';
export default rootShouldForwardProp;


//////////////////
// WEBPACK FOOTER
// ../@mui/material/styles/rootShouldForwardProp.js
// module id = 866
// module chunks = 25